import React from 'react';
import { ItemListConfig, FooterListConfig } from '../../../types/Drawer';
import HomeIcon from '../../../assests/icons/home.png';
import ApplicationIcon from '../../../assests/icons/application.png';
import AnalyticsIcon from '../../../assests/icons/Analytics.svg';
import WorkflowIcon from '../../../assests/icons/workflow.png';
import DevHubIcon from '../../../assests/icons/dev-hub.png';
import AccountIcon from '../../../assests/icons/account.png';
import leftArrowIcon from '../../../assests/icons/leftArrow.svg';
import rightArrowIcon from '../../../assests/icons/rightArrow.svg';

export const itemListConfig: ItemListConfig[] = [
  {
    key: 'home',
    text: 'Home',
    tooltip: 'Home',
    disabled: false,
    hidden: false,
    id: 'drawer__menu_home',
    icon: (<img src={HomeIcon} alt="home" />),
    collapsedIcon: (<img src={HomeIcon} alt="home" />),
    onClickFunctionName: 'home',
  },
  {
    key: 'applications',
    text: 'Applications',
    tooltip: 'Applications',
    disabled: false,
    hidden: false,
    id: 'drawer__menu_applications',
    icon: (<img src={ApplicationIcon} alt="application" />),
    collapsedIcon: (<img src={ApplicationIcon} alt="application" />),
    onClickFunctionName: 'applications',
  },
  {
    key: 'analytics',
    text: 'Analytics',
    subMenuKey: 'analytics',
    tooltip: 'Analytics',
    disabled: false,
    hidden: false,
    id: 'drawer__menu_analytics',
    icon: (<img src={AnalyticsIcon} alt="analytics" />),
    collapsedIcon: (<img src={AnalyticsIcon} alt="analytics" />),
    onClickFunctionName: 'analytics',
  },
  {
    key: 'workflows',
    text: 'Workflows',
    tooltip: 'Workflows',
    disabled: false,
    hidden: false,
    id: 'drawer__menu_workflows',
    icon: (<img src={WorkflowIcon} alt="workflows" />),
    collapsedIcon: (<img src={WorkflowIcon} alt="workflows" />),
    onClickFunctionName: 'workflows',
  },
  {
    key: 'devHub',
    text: 'Dev Hub',
    tooltip: 'Dev Hub',
    subMenuKey: 'devHub',
    disabled: false,
    hidden: false,
    id: 'drawer__menu_dev_hub',
    icon: (<img src={DevHubIcon} alt="devHub" />),
    collapsedIcon: (<img src={DevHubIcon} alt="devHub" />),
    onClickFunctionName: 'devHub',
  },
  {
    key: 'account',
    text: 'Account',
    tooltip: 'Account',
    subMenuKey: 'account',
    disabled: false,
    hidden: false,
    id: 'drawer__menu_account',
    icon: (<img src={AccountIcon} alt="account" />),
    collapsedIcon: (<img src={AccountIcon} alt="account" />),
    onClickFunctionName: 'account',
  },
];

export const footerListConfig: FooterListConfig[] = [
  {
    key: 'collapse',
    text: 'Collapse',
    tooltip: 'Expand',
    containsSubMenu: false,
    disabled: false,
    hidden: false,
    id: 'drawer__menu_collapse',
    icon: (<img src={leftArrowIcon} alt="collapse" />),
    collapsedIcon: (<img src={rightArrowIcon} alt="collapse" />),
    onClickFunctionName: 'collapse',
  },
];
